import PermissionGateDropdownItem from "components/PermissionGate/DropdownMenuItem";

import { showMarkAsBadConfirmation } from "./Modal";
import { MarkAsBadProps } from "./types";

const MarkAsBadDropdownItem = ({
  moduleId,
  id,
  versionNumber,
  versionState,
  onClickCb,
  canMarkModuleAsBad,
}: MarkAsBadProps) => {
  const handleShowModal = () => {
    showMarkAsBadConfirmation({
      id,
      versionState,
      versionNumber,
      moduleId,
    });
    onClickCb?.();
  };

  return (
    <PermissionGateDropdownItem access={canMarkModuleAsBad} onAction={handleShowModal}>
      Mark as bad
    </PermissionGateDropdownItem>
  );
};

export default MarkAsBadDropdownItem;
